export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-IN'));
export const money = (v, c = 'INR') =>
  (v == null ? '—' : `${c === 'INR' ? '₹' : ''}${Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`);
export const rupees2 = (v, c = 'INR') =>
  (v == null ? '—' : `${c === 'INR' ? '₹' : ''}${Number(v).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const pct = (v, digits = 0) => (v == null ? '—' : `${(v * 100).toFixed(digits)}%`);

export const FEATURE_LABEL = {
  negatives: 'Block', harvest: 'Promote', conflicts: 'Overlap',
  discovery: 'Add', listing: 'Listing',
};

export const AFFORD_CLASS = {
  'profitable at a competitive bid': 'afford_competitive',
  'profitable at the low end only': 'afford_low',
  'not affordable at current conversion': 'afford_no',
  'no conversion data yet': 'afford_unknown',
};
